var map = {
	"./logo-1-light.png": 62,
	"./logo-10-light.png": 87,
	"./logo-11-light.png": 88,
	"./logo-12-light.png": 89,
	"./logo-2-light.png": 45,
	"./logo-3-light.png": 91,
	"./logo-4-light.png": 63,
	"./logo-5-light.png": 93,
	"./logo-6-light.png": 94,
	"./logo-7-light.png": 46,
	"./logo-8-light.png": 96,
	"./logo-9-light.png": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 202;